import React, { useRef, useState, useEffect } from "react";
import {
  Form,
  DatePicker,
  Radio,
  Row,
  Col,
  Select,
  Input,
  Button,
  Table,
  message,
  Popconfirm,
} from "antd";
import moment from "moment";
import { request } from "../../../../utils/fetch";
import { getRelevanceCompany } from "../../../../api/api";
import ViewModal from "./ViewModal";

const { RangePicker } = DatePicker;
const { Option } = Select;

const itemStyle = { width: "300px", marginRight: "15px" };
const labelStyleObj = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

const AgeControl = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const viewModalRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [companyCodeList, setcompanyCodeList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条`,
  });
  useEffect(() => {
    getRelevanceCompanyall();
    getTableData();
  }, []);
  const handlerChange = (dates, dateStrings) => {
    if (dates === null) {
      form.setFieldsValue({
        rangeDate: null,
      });
    }
  };
  // 获取所有企业
  const getRelevanceCompanyall = async () => {
    const res = await getRelevanceCompany();
    if (res) {
      setcompanyCodeList(res);
    }
  };
  const radioChange = (e) => {
    const startDate = moment()
      .subtract(e.target.value - 1, "days")
      .format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    form.setFieldsValue({
      rangeDate: [moment(startDate), moment(endDate)],
    });
  };
  // 重置
  const resetForm = () => {
    form.resetFields();
  };
  // 查询
  const submit = () => {
    // 查询时重置到第一页
    setPagination({
      ...pagination,
      current: 1,
    });
    getTableData({ pageNum: 1 });
  };
  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
    });
    getTableData({
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    });
  };
  // 获取数据列表
  const getTableData = async (pageParams = {}) => {
    const { keyword, rangeDate, companyCode } = form.getFieldsValue();
    setLoading(true);
    const params = {
      keyword,
      beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
      endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
      companyCode: companyCode,
      pageNum: pageParams.pageNum || pagination.current,
      pageSize: pageParams.pageSize || pagination.pageSize,
    };
    try {
      const res = await request.get("/platform/staffRisk/list", params);
      setTableData(res.list);
      setPagination({
        ...pagination,
        total: res.totalCount,
      });
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };
  // 导出
  const exportExcel = async () => {
    try {
      const { keyword, rangeDate, companyCode } = form.getFieldsValue();
      const params = {
        keyword,
        beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
        endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
        companyCodde: companyCode,
      };
      request.downloadTemplate("/platform/staffRisk/export", params);
    } catch (error) {
      message.error(error);
    }
  };
  // 查看
  const handleDetail = (record) => {
    viewModalRef.current.show({ ...record, type: "view" });
  };
  // 解除
  const handleDelete = (record) => {
    viewModalRef.current.show({ ...record, type: "delete" });
  };
  const handleSuccess = () => {
    getTableData();
  };

  // 列表字段
  const tableColumns = [
    {
      title: "申请加入时间",
      dataIndex: "createTime",
      key: "createTime",
      width: 180,
      align: "center",
      render: (row) => {
        return row ? moment(row).format("YYYY-MM-DD HH:mm:ss") : "";
      },
    },
    {
      title: "姓名",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "手机号",
      dataIndex: "phone",
      key: "phone",
      align: "center",
    },
    {
      title: "身份证号",
      dataIndex: "idNumber",
      key: "idNumber",
      align: "center",
    },
    {
      title: "年龄",
      dataIndex: "age",
      key: "age",
      align: "center",
    },
    {
      title: "申请加入企业",
      dataIndex: "companyName",
      key: "companyName",
      align: "center",
    },

    {
      title: "状态",
      dataIndex: "relieveFlagName",
      key: "relieveFlagName",
      align: "center",
    },
    {
      title: "操作",
      dataIndex: "operation",
      key: "operation",
      align: "center",
      render: (text, record) => (
        <div>
          <Button type="link" onClick={() => handleDetail(record)}>
            查看
          </Button>
          {record.relieveFlag !== 1 && (
            <Button type="link" onClick={() => handleDelete(record)}>
              解除
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Form form={form} {...labelStyleObj} labelAlign="left">
        <Row>
          <Form.Item label="时间" name="rangeDate">
            <RangePicker
              allowClear
              format={"YYYY-MM-DD"}
              onChange={handlerChange}
            />
          </Form.Item>
          <Form.Item style={{ width: "600px", marginLeft: "15px" }}>
            <Radio.Group onChange={radioChange}>
              <Radio value={1}>今天</Radio>
              <Radio value={7}>近7天</Radio>
              <Radio value={30}>近30天</Radio>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row>
          <Form.Item label="企业名称" name="companyCode" style={itemStyle}>
            <Select
              allowClear
              placeholder="全部"
              showSearch
              optionFilterProp="children"
            >
              {companyCodeList.map((e) => (
                <Option key={e.companyCode} value={e.companyCode}>
                  {e.companyName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item style={itemStyle} name="keyword" label="关键字">
            <Input placeholder="姓名丨身份证号丨手机号 | 所在城市" />
          </Form.Item>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={submit}
              style={{ marginRight: "15px" }}
            >
              查询
            </Button>
            <Button onClick={resetForm}>重置</Button>
            <Button
              type="primary"
              style={{ marginLeft: "15px" }}
              onClick={exportExcel}
            >
              导出
            </Button>
          </Col>
        </Row>
      </Form>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={pagination}
        onChange={handleTableChange}
        bordered
        size="middle"
        loading={loading}
        rowKey={(record) => record.id}
      />
      <ViewModal ref={viewModalRef} onSuccess={handleSuccess} />
    </div>
  );
};

export default AgeControl;
